<template>
  <h2 class="text-white"><b>eBupot Masa 2126 - V.1.0</b></h2>
</template>
